/**
 * This class defines a light source.
 */
class Light {
  constructor() {
    // TODO
  }

  // TODO: Implement this.
}

export {Light};
